var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8506 3.04046C15.27 3.39988 15.3185 4.03118 14.9591 4.4505C12.8369 6.92219 10.6842 9.39391 8.30092 11.6183C7.65468 12.2214 6.75863 13.1997 5.79985 13.1997C5.11384 13.1997 4.50805 12.7603 4.01242 12.3293C2.84479 11.314 1.86568 10.0347 0.980975 8.77368C0.66426 8.32123 0.773941 7.69719 1.22639 7.38048C1.6788 7.06379 2.30226 7.17378 2.619 7.62613L2.6202 7.62784C3.41237 8.7534 4.28069 9.91221 5.32478 10.8201C5.49938 10.9719 5.64334 11.0781 5.75379 11.1445C6.1825 10.8637 6.56311 10.5045 6.93628 10.1562C9.26556 7.98217 11.364 5.56277 13.4404 3.14918C13.7998 2.72986 14.4313 2.68103 14.8506 3.04046Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIconGray);
export default __webpack_public_path__ + "static/media/correct-icon-gray.99780d6b074a208bd95ceb65cbd1a575.svg";
export { ForwardRef as ReactComponent };